import _forEach from 'lodash/forEach'
import track from "../../../components/track";

const form = new Vue({
    el: '#mgv_form',
    data() {
        return {
            form: {
                actualClientId: window.actualClient.id,
                actualClientName: window.actualClient.name,
                actualClientId2: window.actualClient.id2,
                actualClientPhone: '',
                actualClientName2: '',
                info: {
                    0: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    1: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    2: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    3: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    4: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                },
                terms: false,
            },
            default: {
                actualClientId: window.actualClient.id,
                actualClientName: window.actualClient.name,
                actualClientId2: window.actualClient.id2,
                actualClientPhone: '',
                actualClientName2: '',
                info: {
                    0: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    1: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    2: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    3: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                    4: {
                        name: '',
                        phone: '',
                        comment: '',
                    },
                },
                terms: false,
            },
            errors: {
                actualClientName2: false,
                actualClientPhone: false,
                info: {
                    0: {
                        name: false,
                        phone: false,
                    },
                    1: {
                        name: false,
                        phone: false,
                    },
                    2: {
                        name: false,
                        phone: false,
                    },
                    3: {
                        name: false,
                        phone: false,
                    },
                    4: {
                        name: false,
                        phone: false,
                    },
                },
                terms: false,
            },
        }
    },
    methods: {
        clearForm() {
            this.form = Object.assign(this.form, this.default);
        },
        submit2(){
            track.event({
                eventCategory: "Promoció",
                eventAction: "jo-tambe-vull-ser-goufone",
                eventLabel: "Veins"
            })
            let hasErrors = false;
            this.errors.actualClientPhone = false;
            this.errors.actualClientName2 = false;
            this.errors.info[0].phone = false;
            this.errors.info[0].name = false;
            var phoneRGEX = /^[0-9]{9}$/;
            if(!this.form.actualClientId || !this.form.actualClientName || !this.form.actualClientId2){
                var phoneResultClient = phoneRGEX.test(this.form.actualClientPhone);
                if(!phoneResultClient){
                    this.errors.actualClientPhone = true;
                    hasErrors = true
                }
                if(!this.form.actualClientName2.length){
                    this.errors.actualClientName2 = true
                    hasErrors = true
                }
            }
            var phoneResultFriend = phoneRGEX.test(this.form.info[0].phone);
            if(!phoneResultFriend){
                this.errors.info[0].phone = true;
                hasErrors = true
            }
            if(!this.form.info[0].name.length){
                this.errors.info[0].name = true
                hasErrors = true
            }


            this.errors.terms = false
            if(!this.form.terms){
                this.errors.terms = true
                hasErrors = true
            }

            if(hasErrors) {
                return false
            }
            let payload = {};
            if(!this.form.actualClientId || !this.form.actualClientName || !this.form.actualClientId2){
                payload = {
                    info: {
                        0: this.form.info[0]
                    },
                    actualClientPhone: this.form.actualClientPhone,
                    actualClientName: this.form.actualClientName2,
                    terms: this.form.terms
                }
            }else {
                payload = {
                    info: {
                        0: this.form.info[0]
                    },
                    actualClientId: this.form.actualClientId,
                    actualClientName: this.form.actualClientName,
                    actualClientId2: this.form.actualClientId2,
                    terms: this.form.terms
                }
            }

            axios.post(this.$el.action, payload);
            this.clearForm();
            window.location.href = "/descompte-veins-gracies?id=newAmics&name="+payload.actualClientId;


            // window.location.href = "/mgm-gracies?id="+ payload.actualClientId +"&name="+payload.actualClientId;
            // if(!this.validateInputs()){
            //     return false
            // }
            // if(!this.form.info[0]) return false
            // this.sendData();
        }
    }
});

